import React from 'react';
import Styles from './index-pc.module.scss';

export default function TAndC(props: ITAndC) {
  const { tc } = props;

  if (!tc) { 
    return null;
  }

  return (
    <div className={Styles.tc} dangerouslySetInnerHTML={{ __html: tc }} >
    </div>
  );
}

interface ITAndC {
  tc: string;
}
